const loop = <A>(length, render: { (index): A }): Array<A> => {
    const arr: Array<A> = []
    for (let i = 0; i < length; i++) {
        arr.push(render(i))
    }
    return arr
}

export = loop
